import React, { useContext, useState } from 'react';
import FullCalendar from '@fullcalendar/react';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import AriCalendarFilterBar from './calendar/AriCalendarFilterBar';
import { ContextCalendarAri } from '../../../contextsProperty/ContextCalendarAri';
import ResultsIndicator from '../ResultsIndicator';
import CalendarPopUp from './calendar/popup/CalendarPopup';
import { formatDate } from '../../../../utils/formatDates';
import '../../../../stylesheets/stylesLayout/calendarView.scss';
import useTranslate from '../../../../customHooks/useTranslate';
import useCalendarEvents from './calendar/useCalendarEvents'; // Custom hook
import CalendarConfiguration from './calendar/CalendarConfiguration';
import EventContent from './calendar/EventContent';
import { ContextUserProfile } from '../../../../contexts/UserProfileContext';

const AriCalendarView = React.memo(() => {
    const { items, currentResults, totalResults, isLoading, page } =
        useContext(ContextCalendarAri);
    const { language } = useContext(ContextUserProfile);

    const [isOpen, setIsOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState(false);
    const [selectedEvents, setSelectedEvents] = useState(false);

    const productText = useTranslate('products');
    const totalAvailabilityText = useTranslate('full_availability');
    const lowestRateText = useTranslate('lowest_rate');

    // Custom hook for handling events with useMemo optimization
    const { events, groupedItems } = useCalendarEvents(items);

    const handleOpen = () => setIsOpen(true);
    const handleClose = () => setIsOpen(false);

    const handleEventClick = arg => {
        const date = arg.event.startStr;
        const products = groupedItems[date]?.products || [];
        setSelectedEvents(products); // Pasamos los items agrupados
        setSelectedDate(formatDate(date, language));
        handleOpen();
    };

    return (
        <>
            {page > 0 && (
                <div style={{ position: 'absolute', top: 27, left: 60 }}>
                    <ResultsIndicator
                        currentResults={currentResults}
                        totalResults={totalResults}
                        isLoading={isLoading}
                    />
                </div>
            )}

            {/* Mostramos el shimmer si está cargando */}
            <div className='calendar-container'>
                <AriCalendarFilterBar />
                {isLoading ? (
                    // Mostramos un shimmer skeleton mientras está en loading
                    <div className='shimmer-box shimmer'></div>
                ) : (
                    <CalendarConfiguration>
                        <FullCalendar
                            plugins={[dayGridPlugin, interactionPlugin]}
                            initialView='dayGridMonth'
                            weekends={true}
                            events={events}
                            eventContent={eventInfo => (
                                <EventContent
                                    eventInfo={eventInfo}
                                    productText={productText}
                                    totalAvailabilityText={
                                        totalAvailabilityText
                                    }
                                    lowestRateText={lowestRateText}
                                />
                            )}
                            height='100%'
                            eventClick={handleEventClick}
                            dayCellClassNames='fc-day-hover'
                            initialDate={items[0]?.date}
                        />
                    </CalendarConfiguration>
                )}
            </div>

            <CalendarPopUp
                isOpen={isOpen}
                handleClose={handleClose}
                selectedEvents={selectedEvents}
                selectedDate={selectedDate}
            />
        </>
    );
});
// Añade el displayName para evitar el warning de ESLint
AriCalendarView.displayName = 'AriCalendarView';

export default AriCalendarView;
